import { Divider, Row } from "antd";
import { SeasonView } from "components/SeasonView/SeasonView";
import { BackToButton } from "components/Shared/BackToButton";
import { SeasonTitle } from "components/Shared/SeasonTitle";
import { useFetchSeasonRoster } from "hooks/useSeasonRosterApi";
import { useFetchSeasonStaff } from "hooks/useSeasonStaffApi";
import { useFetchSeason } from "hooks/useSeasonsApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

export const AdminSeasonPage = () => {
  const { customerId, sport, organizationId, entityId: entityIdFromParams, seasonId: seasonIdFromParams } = useParams();
  const entityId = entityIdFromParams || "undefined";
  const seasonId = seasonIdFromParams || "undefined";
  const { formatMessage } = useIntl();
  const { data: seasonResponse, isLoading: isSeasonLoading } = useFetchSeason({
    entityId,
    seasonId,
  });
  const season = seasonResponse?.data?.[0];
  const { data: seasonRosterResponse, isLoading: isSeasonRosterLoading } = useFetchSeasonRoster({ entityId, seasonId });
  const roster = seasonRosterResponse?.data || [];
  const { data: seasonStaffResponse, isLoading: isSeasonStaffLoading } = useFetchSeasonStaff({ entityId, seasonId });
  const staff = seasonStaffResponse?.data || [];
  const isLoading = isSeasonLoading || isSeasonRosterLoading || isSeasonStaffLoading;

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <SeasonTitle isLoading={isLoading} season={season} />
        <BackToButton
          to={`/${customerId}/${sport}/${organizationId}/admin`}
          btnText={formatMessage({ id: "back.to.dashboard" })}
        />
      </Row>
      <Divider />
      <SeasonView
        viewOnly={true}
        isLoading={isLoading}
        entityId={entityId}
        season={season}
        roster={roster}
        staff={staff}
      />
    </>
  );
};
